import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "./components/Login";
import LoginAdmin from "./components/LoginAdmin";
import Register from "./components/Register";

import Scanner from "./components/Scanner";
import WriteDocument from "./components/WriteDocument";
import DocumentView from "./components/DocumentView";

import StudentDashboard from "./components/Dashboard/StudentDashBoard";
import TeacherDashboard from "./components/Dashboard/TeacherDashBoard";

import "./App.css";

import ComparisonResults from "./components/ComparisonResults";

import { initSecurityMeasures } from "./utils/security";

import AdminPanel from "./components/AdminPanel";
import ProfilePage from "./components/profile/ProfilePage";
import Navbar from "./components/navbar/Navbar";

import AttendanceHistory from "./components/student/AttendanceHistory";
import AttendanceManagement from "./components/admin/AttendanceManagement";
import Dashboard from "./components/teacher/Dashboard";
import MyDocument from "./components/teacher/MyDocument";
import StudentList from "./components/teacher/StudentList";
import TeacherProfile from "./components/profile/TeacherProfile";
import Home from "./pages/Home";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Privacy from "./components/navbar/Privacy";
import Contactus from "./pages/Contactus";
import CancellRefundPolicy from "./pages/CancellRefundPolicy";
import Analytics from "./components/teacher/Analytics";
import Subscription from "./pages/Subscription";
import StudentDocumentList from "./components/teacher/StudentDocumentList";
import TeacherComparisonResults from "./components/teacher/TeacherComparisonResults";
import SubscriptionDeatils from "./components/student/SubscriptionDeatils";
import Term from "./pages/Term";
import HomeNavbar from "./components/navbar/HomeNavbar";
import ScannerImage from "./components/teacher/Image/ScannerImage";
import ImageDocumentView from "./components/teacher/Image/ImageDocumentView";
import ImageMyDocument from "./components/teacher/Image/ImageMyDocument";
import WriteImageDocument from "./components/student/image/WriteImageDocument";
import ComparisonImageResults from "./components/student/image/ComparisonImageResults";
import TeacherImageComparisonResults from "./components/teacher/Image/TeacherImageComparisonResults";
import UploadAudioDocs from "./components/teacher/audio/UploadAudioDocs";
import SelectImageDoc from "./components/student/image/SelectImageDoc";
import AudioMyDocument from "./components/teacher/audio/AudioMyDocument";
import AudioDocumentView from "./components/teacher/audio/AudioDocumentView";
import AudioExerciseLevels from "./components/teacher/audio/AudioExerciseLevels";
import SelectAudioExerciseLevel from "./components/student/audio/SelectAudioExerciseLevel";
import WriteAudioDocument from "./components/student/audio/WriteAudioDocument";
import ComparisonAudioResults from "./components/student/audio/ComparisonAudioResults";
import SelectAudioDoc from "./components/student/audio/SelectAudioDoc";
import TeacherAudioComparisonResults from "./components/teacher/audio/TeacherAudioComparisonResults";
import DemoWriteImageDocument from "./pages/demo/DemoWriteImageDocument";
import DemoWriteAudioDocument from "./pages/demo/DemoWriteAudioDocument";
import DemoComparisonAudioResults from "./pages/demo/DemoComparisonAudioResults";
// import Home from "./components/Home";

const ProtectedRoute = ({ allowedRoles, children }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user || !allowedRoles.includes(user?.role)) {
    return <Navigate to="/login" />;
  }
  return children;
};

const NonProtectedRouteLayout = ({ user, handleLogout, handleProfile }) => {
  return (
    <div>
      <HomeNavbar user={user} handleLogout={handleLogout} handleProfile={handleProfile} />
      <Outlet />
    </div>
  );
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");

    if (token && storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setIsAuthenticated(true);
      setUser(parsedUser);
    }

    setLoading(false);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  // Determine the default route based on user role
  const getDefaultRoute = () => {
    if (!user) return "/login";
    return user.role === "admin" ? "/admin" : user.role === "teacher" ? "/dashboard/teacher" : "/dashboard/student";
  };

  const handleProfile = () => {
    // Redirect to the profile page
    window.location.href = "/profile";
  };

  return (
    <Router>
      <div className="App">
        {isAuthenticated && <Navbar user={user} handleLogout={handleLogout} handleProfile={handleProfile} />}

        <main className="container">
          <Routes>
            <Route path="/" element={<NonProtectedRouteLayout user={user} handleLogout={handleLogout} handleProfile={handleProfile}></NonProtectedRouteLayout>}>
              <Route path="/" element={<Home />} />

              <Route path="/demo-write-image" element={<DemoWriteImageDocument />} />
              <Route path="/demo-write-audio" element={<DemoWriteAudioDocument />} />
              <Route path="/comparison-audio-results-demo" element={<DemoComparisonAudioResults />} />
              <Route path="/comparison-image-results-demo" element={<ComparisonImageResults />} />
              <Route path="about" element={<About />} />
              <Route path="courses" element={<Pricing />} />
              <Route path="privacy-policy" element={<Privacy />} />
              <Route path="contact" element={<Contactus />} />
              <Route path="cancellation-and-refund-policy" element={<CancellRefundPolicy />} />
              <Route path="terms" element={<Term />} />
            </Route>
            <Route path="/login" element={isAuthenticated ? <Navigate to={getDefaultRoute()} /> : <Login setIsAuthenticated={setIsAuthenticated} setUser={setUser} />} />
            <Route path="/adminlogin" element={isAuthenticated ? <Navigate to={getDefaultRoute()} /> : <LoginAdmin setIsAuthenticated={setIsAuthenticated} setUser={setUser} />} />
            <Route path="/register" element={isAuthenticated ? <Navigate to={getDefaultRoute()} /> : <Register setIsAuthenticated={setIsAuthenticated} setUser={setUser} />} />
            <Route path="/dashboard/student" element={isAuthenticated ? <StudentDashboard user={user} /> : <Navigate to="/login" />} />
            <Route path="/write" element={isAuthenticated ? <WriteDocument /> : <Navigate to="/login" />} />

            <Route path="/select-image-document" element={isAuthenticated ? <SelectImageDoc /> : <Navigate to="/login" />} />
            <Route path="/write-image/:documentId" element={isAuthenticated ? <WriteImageDocument /> : <Navigate to="/login" />} />
            <Route path="/comparison-results/:id" element={isAuthenticated ? <ComparisonResults /> : <Navigate to="/login" />} />
            <Route path="/comparison-image-results/:id" element={isAuthenticated ? <ComparisonImageResults /> : <Navigate to="/login" />} />

            {/* Audio related */}
            <Route path="/select-audio-exercise-level" element={isAuthenticated ? <SelectAudioExerciseLevel /> : <Navigate to="/login" />} />
            <Route path="/select-audio-document/:categoryId" element={isAuthenticated ? <SelectAudioDoc /> : <Navigate to="/login" />} />
            <Route path="/write-audio/:docId" element={isAuthenticated ? <WriteAudioDocument /> : <Navigate to="/login" />} />
            <Route path="/comparison-audio-results/:id" element={isAuthenticated ? <ComparisonAudioResults /> : <Navigate to="/login" />} />

            <Route path="/profile" element={isAuthenticated ? <ProfilePage /> : <Navigate to="/login" />} />
            <Route
              path="/subscription"
              element={
                <ProtectedRoute allowedRoles={["student"]}>
                  <Subscription />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription-details"
              element={
                <ProtectedRoute allowedRoles={["student"]}>
                  <SubscriptionDeatils />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/teacher"
              element={
                <ProtectedRoute allowedRoles={["teacher"]}>
                  <TeacherDashboard user={user} />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="scan" element={<Scanner />} />
              <Route path="document" element={<MyDocument user={user} />} />
              <Route path="documents/:id" element={<DocumentView user={user} />} />
              <Route path="students" element={<StudentList />} />
              <Route path="students/:id" element={<StudentDocumentList user={user} />} />
              <Route path="students/:studentId/documents/:documentId" element={<TeacherComparisonResults />} />
              <Route path="students/:studentId/documents-image/:documentId" element={<TeacherImageComparisonResults user={user} />} />
              <Route path="students/:studentId/documents-audio/:documentId" element={<TeacherAudioComparisonResults user={user} />} />
              <Route path="profile" element={<TeacherProfile user={user} />} />
              <Route path="analytics" element={<Analytics />} />

              {/* Image Document */}
              <Route path="scan-image" element={<ScannerImage />} />
              <Route path="document-image" element={<ImageMyDocument user={user} />} />
              <Route path="documents-image/:id" element={<ImageDocumentView user={user} />} />

              {/* Audio  Document */}
              <Route path="scan-audio" element={<UploadAudioDocs />} />
              <Route path="audio-exercise-levels" element={<AudioExerciseLevels />} />
              <Route path="document-audio/:categoryId" element={<AudioMyDocument user={user} />} />
              <Route path="documents-audio/:id" element={<AudioDocumentView user={user} />} />
            </Route>
            <Route
              path="/attendance/history"
              element={
                <ProtectedRoute allowedRoles={["student"]}>
                  <AttendanceHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
        <footer>
          <p
            style={{
              textAlign: "center",
              padding: "20px",
              backgroundColor: "#f5f5f5",
              color: "#666",
              fontSize: "14px",
              borderTop: "1px solid #ddd",
              marginTop: "auto",
            }}
          >
            © {new Date().getFullYear()} PITMANSTENO. All rights reserved.
          </p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
